var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "266.52332mm",
    height: "49.93108mm",
    viewBox: "0 0 266.52332 49.93108",
    id: "svg1",
    xmlSpace: "preserve",
    "inkscapeExport-filename": "logo.sv",
    "inkscapeExport-xdpi": 96,
    "inkscapeExport-ydpi": 96,
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    "inkscapeDocument-units": "mm"
  }, /*#__PURE__*/React.createElement("inkscapePage", {
    x: -2.947923e-7,
    y: -1.7679938e-7,
    width: 266.52332,
    height: 49.93108,
    id: "page3",
    margin: 0,
    bleed: 0
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,268.061 H 889.946 V 0 H 0 Z",
    transform: "translate(-163.34931,-170.2137)",
    id: "path2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 603.219,204.799 H 822.723 V 63.2618 H 603.219 Z",
    transform: "translate(-623.44222,-150.20471)",
    id: "path3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 603.219,204.799 H 822.723 V 63.2618 H 603.219 Z",
    transform: "translate(-791.49459,-202.77611)",
    id: "path4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,268.061 H 889.946 V 0 H 0 Z",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,357.41467)",
    id: "path7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC0",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Layer 1",
    transform: "matrix(0.26458333,0,0,0.26458334,-23.714894,-22.317534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m 0,0 h -22.22 c -19.718,0 -33.142,-13.006 -33.105,-36.099 0,-22.639 13.387,-35.606 33.142,-35.606 H 1.706 v 21.234 h -25.253 v 26.999 H 1.706 41.257 v -26.999 -55.4 h -65.108 c -41.371,0 -72.275,24.686 -72.275,69.81 0,45.542 30.904,70.038 72.275,70.265 H 41.22 V 0 H 1.67 Z m 231.842,34.204 v -52.101 h -58.511 v 45.503 l -46.338,-63.857 46.338,-62.416 v 46.528 h 58.511 v -53.732 h 39.512 V 34.204 Z M 81.869,-105.871 v 52.745 h 13.196 l 36.478,-52.745 z m 14.03,86.912 37.276,53.163 H 81.869 V -18.959 Z M 338.813,-35.833 V 0 h 26.165 c 10.086,0 17.708,-7.204 17.708,-18.125 0,-10.503 -7.622,-17.708 -17.708,-17.708 z m 32.497,70.037 h -72.085 v -140.075 h 39.551 v 35.834 h 32.534 c 28.251,0 52.14,19.149 52.14,51.723 0,35.833 -23.889,52.518 -52.14,52.518",
    style: {
      fill: "#4e86ce",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,217.79907,130.46307)",
    clipPath: "url(#clipPath2)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.970001,
    id: "g6",
    clipPath: "url(#clipPath7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 32.573 c 13.033,0 19.32,4.652 19.32,11.525 0,8.293 -12.355,10.114 -22.464,10.114 -11.01,0 -27.182,-3.035 -40.216,-7.282 l -9.436,32.961 c 9.661,3.028 32.803,7.276 51.451,7.276 43.583,0 64.254,-13.749 64.254,-39.226 0,-13.143 -8.763,-24.465 -24.268,-28.511 19.326,-5.051 29.659,-15.57 29.659,-33.967 0,-23.656 -22.016,-39.833 -69.645,-39.833 -21.119,0 -42.911,5.456 -50.773,7.884 l 10.333,31.949 c 7.637,-2.832 24.711,-7.08 40.44,-7.08 16.177,0 25.384,5.26 25.384,13.143 0,8.294 -8.086,11.525 -24.039,11.525 H 0 Z",
    style: {
      fill: "#57c035",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,831.25627,157.14173)",
    clipPath: "url(#clipPath3)",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 31.228 v -137.491 h -43.135 v 93.415 l -38.417,-20.02 -16.396,28.915 z",
    style: {
      fill: "#57c035",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1055.3261,87.046533)",
    clipPath: "url(#clipPath4)",
    id: "path6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ece57c20d5084b2402c1142804f75412.svg";
export { ForwardRef as ReactComponent };